import { Entity } from '@/interfaces'
import model from './model'
import repository from './repository'

const itineraryItemEntity: Entity = {
  model: model,
  repository: repository,
}

export default itineraryItemEntity
